// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","separatorGrey":"#eceeee","container":"_2tAJSZxL2IlEVho28L-s-m"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/separator/Separator.css
// module id = 992
// module chunks = 1